import React, { useEffect, useState } from "react";
import styles from "./PageLayout.module.scss";
import { Sidebar } from "../Sidebar";
import { Route, Routes, useLocation } from "react-router-dom";
import { Dashboard } from "src/pages/Dashboard";
import { Orders } from "src/pages/Orders";
import { Upsells } from "src/pages/Upsells";
import { Upsell } from "src/pages/Upsell_";
import { Affiliates } from "src/pages/Affiliates";
import { AffiliatedProducts } from "src/pages/AffiliatedProducts";
import { Affiliate } from "src/pages/Affiliate";
import { Products } from "src/pages/Products";
import { Product2 } from "src/pages/Product2";
import { Reviews } from "src/pages/Reviews";
import { Customers } from "src/pages/Customers";
import { Customer } from "src/pages/Customer";
import { Payouts } from "src/pages/Payouts";
import { Profile } from "src/pages/Profile";
import { NotFoundPage } from "src/pages/not-found-page";
import { Guide } from "src/pages/Guide";
import { Order } from "src/pages/Order";
import { Refunds } from "src/pages/Refunds";
import { Refund } from "src/pages/Refund";
import { Help } from "src/pages/Help";
import { PageLoader } from "../page-loader";
import { useAuth0 } from "@auth0/auth0-react";
import Discounts from "src/pages/Discounts";
import { Discount } from "src/pages/Discount";
import { EmptyState } from "../EmptyState";
import { BoughtProducts } from "src/pages/BoughtProducts";
import Developers from "src/pages/Developers/Developers";
import Subscriptions from "src/pages/Subscriptions";
import Subscription from "src/pages/Subscription";
import OrderSubscription from "src/pages/OrderSubscription";
import Axios from "src/services/api";
import TestModeOverlay from "./TestModeOverlay";

const SIDEBAR_STATE_KEY = "sidebarOpen";

const PageLayout = () => {
  // Initialize the sidebar state from localStorage or default to true
  const [sidebarOpen, setSidebarOpen] = useState(() => {
    // Try to get from localStorage first
    const savedState = localStorage.getItem(SIDEBAR_STATE_KEY);
    if (savedState !== null) {
      return savedState === "true";
    }

    // If not in localStorage, check user preferences
    const me = localStorage.getItem("me");
    if (me) {
      const meData = JSON.parse(me);
      return !meData.navbarClosed;
    }

    // Default to open if no stored preference
    return true;
  });

  // Add collapsed state
  const [isCollapsed, setIsCollapsed] = useState(() => {
    const savedCollapsedState = localStorage.getItem("sidebarCollapsed");
    return savedCollapsedState === "true";
  });

  // Save sidebar state to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem(SIDEBAR_STATE_KEY, String(sidebarOpen));
    
    // Update user preferences in localStorage
    const me = localStorage.getItem("me");
    if (me) {
      const meData = JSON.parse(me);
      // Only update if the value has changed
      if (meData.navbarClosed !== !sidebarOpen) {
        meData.navbarClosed = !sidebarOpen;
        localStorage.setItem("me", JSON.stringify(meData));
      }
    }
  }, [sidebarOpen]);

  // Save collapsed state to localStorage
  useEffect(() => {
    localStorage.setItem("sidebarCollapsed", String(isCollapsed));
    
    // Optionally update user preferences for collapsed state too
    const me = localStorage.getItem("me");
    if (me) {
      const meData = JSON.parse(me);
      if (meData.sidebarCollapsed !== isCollapsed) {
        meData.sidebarCollapsed = isCollapsed;
        localStorage.setItem("me", JSON.stringify(meData));
      }
    }
  }, [isCollapsed]);

  useEffect(() => {
    console.log("Sidebar open state changed:", sidebarOpen);
  }, [sidebarOpen]);

  const location = useLocation();

  // Check for specific routes where we want to force sidebar closed
  useEffect(() => {
    const regex = /^\/products\/(new|[0-9a-zA-Z]+)$/;
    if (regex.test(location.pathname)) {
      setSidebarOpen(false);
      setIsCollapsed(true);
    }
  }, [location.pathname]);

  // // is mobile phone check
  // const [isMobile, setIsMobile] = useState(false);

  // useEffect(() => {
  //   if (window.innerWidth < 768) {
  //     setIsMobile(true);
  //   }

  //   // Add resize listener to handle responsive behavior
  //   const handleResize = () => {
  //     setIsMobile(window.innerWidth < 768);
  //   };

  //   window.addEventListener("resize", handleResize);
  //   return () => window.removeEventListener("resize", handleResize);
  // }, []);

  const me = localStorage.getItem("me");
  const meData = JSON.parse(me || "{}");
  const [isTestMode, setIsTestMode] = useState(meData.testMode);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const me = localStorage.getItem("me");
    if (me) {
      const meData = JSON.parse(me);
      console.log({ testMode: meData.testMode });
      setIsTestMode(meData.testMode);
    }
  }, []);

  const toggleTestMode = () => {
    setIsLoading(true);
    Axios.post("/users/update", {
      testMode: !isTestMode,
    })
      .then((res) => {
        localStorage.setItem("me", JSON.stringify(res.data));
        setIsTestMode(!isTestMode);
        window.location.reload();
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  // if (isMobile) {
  //   return (
  //     <EmptyState
  //       title="Mobile is not yet supported"
  //       buttonText="Go back"
  //       buttonClick={() => (window.location.href = "https://pocketsflow.com")}
  //     />
  //   );
  // }

  return (
    <div
      className={styles.pageLayout + " " + (!sidebarOpen ? styles.notOpen : "") + " " + (isCollapsed ? styles.collapsed : "")}
    >
      {isTestMode && <TestModeOverlay />}
      <Sidebar
        setSidebarOpen={setSidebarOpen}
        sidebarOpen={sidebarOpen}
        isCollapsed={isCollapsed}
        setIsCollapsed={setIsCollapsed}
        toggleTestMode={toggleTestMode}
        isLoading={isLoading}
        isTestMode={isTestMode}
      />
      <div className={styles.layout}>
        <div className={styles.content}>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/guide" element={<Guide />} />

            <Route path="/orders" element={<Orders />} />
            <Route path="/orders/:id" element={<Order />} />
            <Route path="/discounts" element={<Discounts />} />
            <Route path="/discounts/new" element={<Discount />} />
            <Route path="/discounts/:id" element={<Discount />} />
            <Route path="/upsells" element={<Upsells />} />
            <Route path="/upsells/new" element={<Upsell />} />
            <Route path="/upsells/:id" element={<Upsell />} />
            <Route path="/refunds" element={<Refunds />} />
            <Route path="/refunds/new" element={<Refund />} />
            <Route path="/refunds/:id" element={<Refund />} />
            <Route path="/affiliates" element={<Affiliates />} />
            <Route
              path="/affiliated-products"
              element={<AffiliatedProducts />}
            />
            <Route path="/affiliates/new" element={<Affiliate />} />
            <Route path="/affiliates/:id" element={<Affiliate />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/new" element={<Product2 />} />
            <Route path="/products/:id" element={<Product2 />} />
            <Route path="/subscriptions" element={<Subscriptions />} />
            <Route path="/subscriptions/new" element={<Subscription />} />
            <Route path="/subscriptions/:id" element={<Subscription />} />
            <Route path="/bought-products" element={<BoughtProducts />} />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/customers" element={<Customers />} />
            <Route path="/customers/:id" element={<Customer />} />
            <Route path="/payouts" element={<Payouts />} />
            <Route path="/help" element={<Help />} />
            <Route path="/profile/*" element={<Profile />} />
            <Route path="/developers/*" element={<Developers />} />
            <Route path="/logout" element={<Logout />} />
            <Route
              path="/order-subscription/:id"
              element={<OrderSubscription />}
            />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

const Logout = () => {
  const { logout } = useAuth0();
  React.useEffect(() => {
    logout();
  }, [logout]);
  return <PageLoader />;
};

export default PageLayout;
